<ds-item-detail-preview [item]="item"
                        [object]="object"
                        [badgeContext]="badgeContext"
                        [showLabel]="showLabel"
                        [showMetrics]="showMetrics"></ds-item-detail-preview>

<ds-workspaceitem-actions [object]="dso"></ds-workspaceitem-actions>
